import { Autocomplete, Box, Chip, Stack, TextField, Typography } from "@mui/material"

/**
 * Roles picker that disambiguates same-named roles by showing the description (or id
 * fallback) next to the name. The shared RolesAutoComplete uses name-only labels which
 * collapses duplicates visually.
 */
export function RolesPicker({ roles = [], value = [], onChange, size = "small" }) {
    const selected = (roles || []).filter(isSelected)
    return (
        <Autocomplete
            multiple
            size={size}
            options={roles || []}
            value={selected}
            onChange={handleChange}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            renderOption={renderOption}
            renderTags={renderTags}
            renderInput={renderInput}
        />
    )

    function isSelected(r) {
        return value.includes(r.id)
    }

    function handleChange(_, next) {
        onChange((next || []).map(toRoleId).filter(Boolean))
    }

    function toRoleId(r) {
        return r.id
    }

    function getOptionLabel(option) {
        return option?.name || ""
    }

    function isOptionEqualToValue(a, b) {
        return a.id === b.id
    }

    function renderOption(props, option) {
        return (
            <Box component="li" {...props} key={option.id}>
                <Stack>
                    <Typography variant="body2">{option.name}</Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: "monospace" }}>
                        {option.description || option.id}
                    </Typography>
                </Stack>
            </Box>
        )
    }

    function renderTags(tagValue, getTagProps) {
        return tagValue.map(renderTag)

        function renderTag(option, index) {
            return (
                <Chip
                    {...getTagProps({ index })}
                    key={option.id}
                    size="small"
                    label={option.name}
                    title={option.description || option.id}
                />
            )
        }
    }

    function renderInput(params) {
        return <TextField {...params} size={size} placeholder="Add roles…" />
    }
}
